import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_3 = {
  key: 0,
  class: "ant-skeleton ant-skeleton-active css-eq3tly"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ant-skeleton-content" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "ant-skeleton-paragraph" }, [
    /*#__PURE__*/_createElementVNode("li")
  ])
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_7 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_8 = { class: "ant-input-group-addon ss-btn-campo" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Consultar CNPJ na Receita Federal", -1)
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-11" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-11" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_22 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_23 = { class: "ant-input-group-addon" }
const _hoisted_24 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_25 = { class: "ant-input-group-addon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_cnpj = _resolveComponent("campo-cnpj")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_selecionar_tipo_atividade = _resolveComponent("selecionar-tipo-atividade")!
  const _component_campo_cpf = _resolveComponent("campo-cpf")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    spinning: _ctx.state.consultandoCnpj
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_form_item, {
              label: "Pessoa",
              class: "ss-margin-campos",
              rules: [{ required: true }]
            }, {
              default: _withCtx(() => [
                (_ctx.state.carregandoTipoPessoa)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_select, {
                  value: _ctx.computedTipoPessoa,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedTipoPessoa) = $event)),
                  placeholder: "Selecione",
                  style: {"width":"100%"},
                  options: _ctx.state.listaTipoPessoa
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createVNode(_component_a_form_item, {
              label: "CNPJ",
              class: "ss-margin-campos",
              rules: [{ required: true }]
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_campo_cnpj, {
                    valor: _ctx.computedCnpj,
                    "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedCnpj) = $event))
                  }, null, 8, ["valor"]),
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_a_tooltip, { placement: "topRight" }, {
                      title: _withCtx(() => [
                        _hoisted_9
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.consultaCNPJ(_ctx.computedCnpj)))
                        }, [
                          _createVNode(_component_icone, {
                            style: {"height":"12px","width":"60px","margin-left":"-16px"},
                            nome: "receita-federal"
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.computedTipoPessoa === _ctx.ETipoPessoa.Juridica]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_10, [
            (_ctx.computedTipoPessoa === _ctx.ETipoPessoa.Juridica)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "Tipo de atividade",
                  class: "ss-margin-campos",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_tipo_atividade, {
                      codigoSelecionado: _ctx.computedTipoAtividade,
                      "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedTipoAtividade) = $event))
                    }, null, 8, ["codigoSelecionado"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _ctx.computedTipoPessoa === _ctx.ETipoPessoa.Juridica]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_11, [
            _createVNode(_component_a_form_item, {
              label: "Razão social",
              class: "ss-margin-campos",
              rules: [{ required: true }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tooltip, { title: _ctx.computedRazaoSocial }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "250",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedRazaoSocial) = $event)),
                      onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.blurNome && _ctx.blurNome(...args)))
                    }, null, 544), [
                      [_vModelText, _ctx.computedRazaoSocial]
                    ])
                  ]),
                  _: 1
                }, 8, ["title"])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.computedTipoPessoa === _ctx.ETipoPessoa.Juridica]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _createVNode(_component_a_form_item, {
              label: "Nome fantasia",
              class: "ss-margin-campos",
              rules: [{ required: true }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tooltip, { title: _ctx.computedNomeFantasia }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "60",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedNomeFantasia) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.computedNomeFantasia]
                    ])
                  ]),
                  _: 1
                }, 8, ["title"])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.computedTipoPessoa === _ctx.ETipoPessoa.Juridica]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_13, [
            _createVNode(_component_a_form_item, {
              label: "CPF",
              class: "ss-margin-campos",
              rules: [{ required: true }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_campo_cpf, {
                  valor: _ctx.computedCpf,
                  "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedCpf) = $event)),
                  onBlur: _ctx.blurCpfCnpj
                }, null, 8, ["valor", "onBlur"])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.computedTipoPessoa === _ctx.ETipoPessoa.Fisica]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_14, [
            _createVNode(_component_a_form_item, {
              label: "Nome completo",
              class: "ss-margin-campos",
              rules: [{ required: true }]
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: "250",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.computedNomeCompleto) = $event)),
                  onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.blurNome && _ctx.blurNome(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.computedNomeCompleto]
                ])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.computedTipoPessoa === _ctx.ETipoPessoa.Fisica]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_15, [
            _createVNode(_component_a_form_item, {
              label: "Nome abreviado",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: "100",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.computedNomeAbreviado) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.computedNomeAbreviado]
                ])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.computedTipoPessoa === _ctx.ETipoPessoa.Fisica]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_16, [
            _createVNode(_component_a_form_item, {
              label: "Documento identificação",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: "20",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.computedDocumentoIdentificacao) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.computedDocumentoIdentificacao]
                ])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.computedTipoPessoa === _ctx.ETipoPessoa.Estrangeira]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_17, [
            _createVNode(_component_a_form_item, {
              label: "Nome completo",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: "250",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.computedNomeCompletoEstrangeiro) = $event)),
                  onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.blurNome && _ctx.blurNome(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.computedNomeCompletoEstrangeiro]
                ])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.computedTipoPessoa === _ctx.ETipoPessoa.Estrangeira]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_18, [
            _createVNode(_component_a_form_item, {
              label: "Nome abreviado",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: "100",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.computedNomeAbreviadoEstrangeiro) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.computedNomeAbreviadoEstrangeiro]
                ])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.computedTipoPessoa === _ctx.ETipoPessoa.Estrangeira]
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _withDirectives(_createElementVNode("div", _hoisted_20, [
            _createVNode(_component_a_form_item, {
              label: "Contato",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: "250",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.computedContato) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.computedContato]
                ])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.computedTipoPessoa === _ctx.ETipoPessoa.Juridica]
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_a_form_item, {
              label: "Telefone",
              class: "ss-margin-campos",
              rules: [{ required: true }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_campo_telefone, {
                  valor: _ctx.computedTelefone,
                  "onUpdate:valor": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.computedTelefone) = $event))
                }, null, 8, ["valor"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.computedTipoPessoa === _ctx.ETipoPessoa.Juridica?'ant-col ant-col-xs-24 ant-col-xl-9':'ant-col ant-col-xs-24 ant-col-xl-10')
          }, [
            _createVNode(_component_a_form_item, {
              label: "E-mail",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_22, [
                  _createElementVNode("span", _hoisted_23, [
                    _createVNode(_component_icone, {
                      class: "ss-icone",
                      nome: "email"
                    })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.computedEmail) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.computedEmail]
                  ])
                ])
              ]),
              _: 1
            })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.computedTipoPessoa === _ctx.ETipoPessoa.Juridica?'ant-col ant-col-xs-24 ant-col-xl-7':'ant-col ant-col-xs-24 ant-col-xl-10')
          }, [
            _createVNode(_component_a_form_item, {
              label: "Site",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, [
                    _createVNode(_component_icone, {
                      class: "ss-icone",
                      nome: "site"
                    })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.computedSite) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.computedSite]
                  ])
                ])
              ]),
              _: 1
            })
          ], 2)
        ])
      ])
    ]),
    _: 1
  }, 8, ["spinning"]))
}